import React from 'react';
import SimpleHero from '../components/SimpleHero/SimpleHero';
import FeatureList from '../components/Minimal/FeatureList';
import savingsImg from "../assets/images/saving.png"

import bg from "../assets/images/ContentImageHandlerdcaa.jpg"
const Savings = () => {
  return (
    <div>
      <SimpleHero
        title="High‑yield savings, made simple"
        subtitle="Grow automatically with transfers and round‑ups. No monthly fees."
        primaryLabel="Start saving"
        primaryHref="/DirectDeposit"
        variant="sofi"
        imageSrc={savingsImg}
        imageAlt="Savings app preview"
        imageOn="right"
        tiltImage
        badges={["High yield","No monthly fees","Auto‑save"]}
      />
      <FeatureList
        items={[
          { title: 'No Monthly Fees', desc: 'Enjoy a hassle-free banking experience with no monthly maintenance fees.' },
          { title: 'Overdraft Protection', desc: 'Stay protected with options to cover overdrafts on your account.' },
          { title: 'Mobile Banking', desc: 'Manage your account anytime, anywhere with our mobile app.' },
        ]}
      />
      <section className="section text-center">
        <div className='gn-button-div'>
        <a className='btn btn-gn-primary' href='/DirectDeposit'>Open an Account</a>
        </div>
      </section>
    </div>
  );
};

export default Savings;
